interface HeaderProps {
  onAddClick: () => void;
  onRefreshClick: () => void;
  onMenuClick: () => void;
  isChecking: boolean;
}

export function Header({ onAddClick, onRefreshClick, onMenuClick, isChecking }: HeaderProps) {
  return (
    <header className="bg-gray-800 border-b border-gray-700 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-center gap-3">
            <button
              onClick={onMenuClick}
              className="lg:hidden p-2 -ml-2 text-gray-300 hover:text-white"
              aria-label="Ouvrir le menu"
            >
              ☰
            </button>
            <h1 className="text-3xl font-bold text-white">📊 My Price Tracker</h1>
          </div>
          <div className="flex flex-wrap gap-3">
            <button
              onClick={onAddClick}
              className="px-4 py-2 bg-green-600 hover:bg-green-500 text-white font-medium rounded-lg transition-colors flex items-center gap-2"
            >
              <span>➕</span> Ajouter un produit
            </button>
            <button
              onClick={onRefreshClick}
              disabled={isChecking}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-500 disabled:bg-blue-400 text-white font-medium rounded-lg transition-colors flex items-center gap-2"
            >
              <span className={isChecking ? 'animate-spin' : ''}>🔄</span> Rafraîchir
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}